// extracted by mini-css-extract-plugin
export default {"Logout":"logout_Logout__yAyYL"};